module.exports = {
  "country": "FR",
  "artist": "Joëlle Ursull",
  "song": "White and Black Blues",
  "year": "1990",
  "place": "2",
  "spotify": "663Tj0JStDI8Lb7sZgKD78"
};